/**
 * Cleaning equipment handover (Layers 1–2).
 * Matches public.equipment_assets, public.staff_equipment, public.equipment_protocols.
 * Status changes go through public RPCs (private schema implementation).
 * Generated Database types in integrations/supabase/types.ts should be regenerated after the migration is applied.
 */

export const EQUIPMENT_PROTOCOL_STORAGE_BUCKET = 'equipment-protocols';

export const EQUIPMENT_RPC = {
  initiateHandover: 'initiate_equipment_handover',
  initiateReturn: 'initiate_equipment_return',
  respond: 'respond_equipment_protocol',
  cancel: 'cancel_equipment_protocol',
  setEvidence: 'set_equipment_protocol_evidence',
  retireAsset: 'retire_equipment_asset',
} as const;

export type EquipmentAssetCategory = 'tool' | 'other';

export type EquipmentAssetStatus =
  | 'available'
  | 'pending_handover'
  | 'assigned'
  | 'pending_return'
  | 'retired';

export interface EquipmentAsset {
  id: string;
  org_id: string;
  name: string;
  category: EquipmentAssetCategory;
  serial_number: string | null;
  status: EquipmentAssetStatus;
  current_holder_id: string | null;
  notes: string | null;
  created_by: string | null;
  created_at: string;
  updated_at: string;
}

export type StaffEquipmentType = 'key' | 'card' | 'other';

export type StaffEquipmentStatus =
  | 'pending_handover'
  | 'assigned'
  | 'pending_return'
  | 'returned';

export interface StaffEquipmentItem {
  id: string;
  org_id: string;
  staff_id: string;
  type: StaffEquipmentType;
  name: string;
  status: StaffEquipmentStatus;
  assigned_at: string | null;
  returned_at: string | null;
  created_by: string | null;
  created_at: string | null;
}

export type EquipmentProtocolKind = 'asset' | 'key_card';

export type EquipmentProtocolDirection = 'handover' | 'return';

export type EquipmentProtocolStatus =
  | 'pending'
  | 'accepted'
  | 'rejected'
  | 'cancelled';

export interface EquipmentProtocol {
  id: string;
  org_id: string;
  kind: EquipmentProtocolKind;
  asset_id: string | null;
  staff_equipment_id: string | null;
  worker_id: string;
  direction: EquipmentProtocolDirection;
  status: EquipmentProtocolStatus;
  initiated_by: string;
  responded_by: string | null;
  condition_notes: string | null;
  photo_urls: string[];
  rejection_reason: string | null;
  initiated_at: string;
  responded_at: string | null;
  created_at: string;
}
